goog.provide("shadow.js.shim.module$ol$proj");
goog.provide("module$shadow_js_shim_module$ol$proj");
shadow.js.shim.module$ol$proj = shadow.js.nativeProvides["ol/proj"] = shadow$bridge("ol/proj");
module$shadow_js_shim_module$ol$proj.default = shadow.js.shim.module$ol$proj;
